export interface HrLifecycleDashboard {
  owningCompanyId?: number;
  activeOnboardingPlans?: number;
  completedOnboardingPlans?: number;
  overdueOnboardingPlans?: number;
  overdueOnboardingTasks?: number;
  activeOffboardingPlans?: number;
  completedOffboardingPlans?: number;
  overdueOffboardingPlans?: number;
  overdueOffboardingTasks?: number;
  pendingActionRequests?: number;
  pendingTransferRequests?: number;
  pendingTerminationRequests?: number;
  pendingCompensationRequests?: number;
  templates?: HrOnboardingTemplate[];
  activeOnboarding?: HrOnboardingPlan[];
  activeOffboarding?: HrOffboardingPlan[];
  recentActionRequests?: HrEmployeeActionRequest[];
}

export interface HrOnboardingTemplate {
  templateId?: number;
  owningCompanyId?: number;
  templateCode?: string;
  templateName?: string;
  workerCategory?: string;
  description?: string;
  active?: boolean;
  systemDefault?: boolean;
  createdAt?: string;
  updatedAt?: string;
  tasks?: HrOnboardingTemplateTask[];
}

export interface HrOnboardingTemplateTask {
  templateTaskId?: number;
  templateId?: number;
  taskCode?: string;
  taskName?: string;
  taskDescription?: string;
  ownerType?: string;
  sequenceNo?: number;
  requiredTask?: boolean;
  blocksActivation?: boolean;
  documentTypeCode?: string;
  productivityTaskTitle?: string;
  dueOffsetDays?: number;
  active?: boolean;
}

export interface HrOnboardingPlan {
  onboardingPlanId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  templateId?: number;
  templateName?: string;
  planStatus?: string;
  startedAt?: string;
  targetCompletionDate?: string;
  completedAt?: string;
  startedByCustomerId?: number;
  completedByCustomerId?: number;
  productivityTaskCount?: number;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
  tasks?: HrOnboardingTask[];
}

export interface HrOnboardingTask {
  onboardingTaskId?: number;
  owningCompanyId?: number;
  onboardingPlanId?: number;
  employeeId?: number;
  templateTaskId?: number;
  taskName?: string;
  taskDescription?: string;
  ownerType?: string;
  sequenceNo?: number;
  requiredTask?: boolean;
  blocksActivation?: boolean;
  documentTypeCode?: string;
  taskStatus?: string;
  dueDate?: string;
  completedAt?: string;
  completedByCustomerId?: number;
  productivityTaskId?: number;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrOffboardingPlan {
  offboardingPlanId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  terminationRequestId?: number;
  planStatus?: string;
  startedAt?: string;
  targetCompletionDate?: string;
  completedAt?: string;
  startedByCustomerId?: number;
  completedByCustomerId?: number;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
  tasks?: HrOffboardingTask[];
}

export interface HrOffboardingTask {
  offboardingTaskId?: number;
  owningCompanyId?: number;
  offboardingPlanId?: number;
  employeeId?: number;
  taskName?: string;
  taskDescription?: string;
  ownerType?: string;
  sequenceNo?: number;
  requiredTask?: boolean;
  taskStatus?: string;
  dueDate?: string;
  completedAt?: string;
  completedByCustomerId?: number;
  productivityTaskId?: number;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrEmployeeActionRequest {
  actionRequestId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  actionType?: string;
  requestStatus?: string;
  requestedByCustomerId?: number;
  requestedAt?: string;
  approvedByCustomerId?: number;
  approvedAt?: string;
  resolvedAt?: string;
  effectiveDate?: string;
  reason?: string;
  currentDepartmentId?: number;
  currentJobId?: number;
  currentPositionId?: number;
  currentManagerEmployeeId?: number;
  currentStatus?: string;
  currentEmployeeType?: string;
  currentWorkLocation?: string;
  requestedDepartmentId?: number;
  requestedJobId?: number;
  requestedPositionId?: number;
  requestedManagerEmployeeId?: number;
  requestedStatus?: string;
  requestedEmployeeType?: string;
  requestedWorkLocation?: string;
  compensationPlaceholderJson?: string;
  productivityTaskId?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrActivationReadiness {
  owningCompanyId?: number;
  employeeId?: number;
  ready?: boolean;
  blockerCount?: number;
  blockers?: string[];
}

export interface HrStartOnboardingRequest {
  owningCompanyId?: number;
  templateId?: number;
  targetCompletionDate?: string;
  notes?: string;
}

export interface HrCompleteTaskRequest {
  owningCompanyId?: number;
  taskStatus?: string;
  notes?: string;
}

export interface HrEmployeeActionInput {
  owningCompanyId?: number;
  effectiveDate?: string;
  reason?: string;
  requestedDepartmentId?: number;
  requestedJobId?: number;
  requestedPositionId?: number;
  requestedManagerEmployeeId?: number;
  requestedEmployeeType?: string;
  requestedWorkLocation?: string;
  compensationPlaceholderJson?: string;
}

export interface HrInviteEmployeeRequest {
  owningCompanyId?: number;
  corporateRole?: string;
  address?: string;
  countryId?: number;
  roleIds?: number[];
}

export const HR_LIFECYCLE_ACTION_TYPES = ['TRANSFER', 'COMPENSATION_CHANGE', 'TERMINATION'];

export const HR_ACTION_STATUSES = ['PENDING', 'APPROVED', 'REJECTED', 'CANCELLED'];

export const HR_PLAN_STATUSES = ['OPEN', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'];

export const HR_TASK_STATUSES = ['OPEN', 'COMPLETED', 'WAIVED', 'NOT_REQUIRED', 'CANCELLED'];

export const HR_TASK_OWNER_TYPES = ['HR', 'EMPLOYEE', 'MANAGER', 'FLEET', 'DISPATCH'];

